const styles = {
    botonContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    boton: {
        margin: "1rem",
        // padding: "0.8rem 4rem",
        backgroundColor: "#dc2626",
        color: "white",
        border: "none",
        cursor: "pointer",
        outline: "none",
        width: "fit-content",
        alignSelf: "center",
    },
};

function BotonSalir({ onClick }) {
    return (
        <div style={styles.botonContainer}>
            <button
            className="fs-5 fw-semibold px-5 py-2 rounded-pill"
                onClick={onClick}
                style={styles.boton}
                onMouseEnter={e => (e.currentTarget.style.backgroundColor = "#d32f2f")}
                onMouseLeave={e => (e.currentTarget.style.backgroundColor = "#f44336")}
            >
                Salir de la fila
            </button>
        </div>
    );
}

export default BotonSalir;
